interface Coords {
  lat: number
  lng: number
}

/**
 * Haversine distance between two coordinates in kilometers.
 */
export function haversineDistance(from: Coords, to: Coords): number {
  const R = 6371 // Earth radius in km
  const dLat = toRad(to.lat - from.lat)
  const dLng = toRad(to.lng - from.lng)

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(from.lat)) * Math.cos(toRad(to.lat)) * Math.sin(dLng / 2) ** 2

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

function toRad(deg: number): number {
  return (deg * Math.PI) / 180
}

/**
 * Human-friendly distance string.
 */
export function formatDistance(km: number): string {
  if (km < 0.1) return '< 100 m'
  if (km < 1) return `${(km * 1000).toFixed(0)} m`
  if (km < 10) return `${km.toFixed(1)} km`
  return `${Math.round(km)} km`
}
